/**
 * Lições do tutorial de configuração do clube.
 * youtubeId: ID do vídeo no YouTube (parte após watch?v=) ou URL completa.
 */
export const CLUB_TUTORIAL_STORAGE_KEY = 'onboarding_steps';
export const CLUB_TUTORIAL_COMPLETED_KEY = 'onboarding_completed';

/** Progresso do tutorial é por clube (mesmo browser / mesmo usuário). */
export function getClubTutorialStorageKey(clubId) {
    if (clubId == null || clubId === '') return null;
    return `${CLUB_TUTORIAL_STORAGE_KEY}:${clubId}`;
}

export function getClubTutorialCompletedKey(clubId) {
    if (clubId == null || clubId === '') return null;
    return `${CLUB_TUTORIAL_COMPLETED_KEY}:${clubId}`;
}

export const baseClubTutorialLessons = [
    {
        id: 'personalizacao',
        title: 'Personalização',
        description:
            'Configure nome, contatos, identidade visual, domínio, banners e menu do clube. Essas informações aparecem para os assinantes no app e no portal.',
        youtubeId: '',
        path: '/clube/personalizacao',
    },
    {
        id: 'planos',
        title: 'Planos',
        description:
            'Crie e gerencie planos de assinatura com preços, benefícios e regras de acesso para os membros do clube.',
        youtubeId: '',
        path: '/clube/planos',
        plansOnly: true,
    },
    {
        id: 'revenda',
        title: 'Revenda',
        description:
            'Configure produtos de revenda, período de teste e integração de pagamentos para clubes que vendem planos.',
        youtubeId: '',
        path: '/clube/revenda',
        resaleOnly: true,
        financeOnly: true,
    },
    {
        id: 'assinantes',
        title: 'Assinantes',
        description:
            'Cadastre, importe e gerencie os assinantes. Controle status, planos vinculados e dados de cada membro.',
        youtubeId: '',
        path: '/clube/assinantes',
    },
    {
        id: 'notificacoes',
        title: 'Notificações',
        description:
            'Envie notificações push para os assinantes do app do clube com título e mensagem personalizados.',
        youtubeId: '',
        path: '/clube/notificacoes',
    },
    {
        id: 'conta',
        title: 'Sua conta',
        description:
            'Gerencie dados de faturamento, contrato e informações administrativas da conta do clube.',
        youtubeId: '',
        path: '/clube/conta',
    },
    {
        id: 'usuarios',
        title: 'Usuários',
        description:
            'Adicione e gerencie usuários com acesso ao painel administrativo do clube e suas permissões.',
        youtubeId: '',
        path: '/clube/usuarios',
    },
    {
        id: 'anunciantes',
        title: 'Anunciantes',
        description:
            'Indique anunciantes pelo link com o código do clube e fortaleça a rede local de lojas e destaques.',
        youtubeId: '',
        path: '/clube/anunciantes',
    },
];

export function getClubTutorialLessons({ hasResale = false, hasPlans = false, canViewFinance = false } = {}) {
    return baseClubTutorialLessons.filter(lesson => {
        if (lesson.resaleOnly && !hasResale) return false;
        if (lesson.plansOnly && !hasPlans) return false;
        if (lesson.financeOnly && !canViewFinance) return false;
        return true;
    });
}

/** Extrai o ID do vídeo a partir de URL ou retorna o valor se já for um ID. */
export function parseYoutubeId(value) {
    if (!value || typeof value !== 'string') return null;
    const trimmed = value.trim();
    if (!trimmed) return null;

    try {
        if (trimmed.includes('youtube.com') || trimmed.includes('youtu.be')) {
            const url = new URL(trimmed.startsWith('http') ? trimmed : `https://${trimmed}`);
            if (url.hostname.includes('youtu.be')) {
                return url.pathname.slice(1).split('/')[0] || null;
            }
            return url.searchParams.get('v') || url.pathname.split('/').pop() || null;
        }
    } catch {
        return trimmed;
    }

    return trimmed;
}
